import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Notification, Loading, Badge, Dialog, Validator, Button, Input, IconButton} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import {LevelApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';

class LevelsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.courseId,
            data: undefined,
            loading: true,
            createBtnLoading: false,
            levelName: '',
            unsavedDescription: '',
            descriptionEditMode: false,
            descriptionSubmitLoading: false
        };

        this.validator = Validator(props.locale.abbreviation);
    }

    componentDidMount() {
        const res = this.checkCourseId();
        if (!res) {
            Notification('error', 'WrongData');
            return;
        }

        this.loadData()
    }

    checkCourseId() {
        const {courseId} = this.props;
        if (courseId) {
            this.setState({courseId});
            return true;
        }
        return false;
    }

    loadData() {
        const {courseId} = this.state;
        LevelApi.GetAdminByCourseId(courseId)
            .then(res => {
                if (res && res.status == 200) {
                    const {data} = res;
                    this.setState({data});
                }
            }).finally(() => {
            this.setState({loading: false});
        })
    }

    _handleLevelClick = (level) => {
        const {history} = this.props;
        const {id} = level;

        history.push({
            pathname: `level?id=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleSubmitAddClick = () => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Level;

        let validationResult = true;
        validationResult = this.validator.fieldValid(pageTranslates.LevelName);

        if (validationResult) {
            this.setState({createBtnLoading: true});
            const {courseId, levelName} = this.state;
            const model = {courseId: parseInt(courseId), title: levelName};

            LevelApi.Create(model)
                .then(res => {
                    if (res.status == 200) {
                        this.loadData();
                        Notification('success', 'Succeed');
                        this.setState({showAddDialog: false});
                    }
                })
                .finally(x => {
                    this.setState({createBtnLoading: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({createBtnLoading: false});
        }
    };

    handleEditDescriptionOnClick = () => {
        const {data} = this.state;
        const {description} = data;

        this.setState({descriptionEditMode: true, unsavedDescription: description});
    };

    handleSubmitDescriptionEdit = () => {
        const {courseId, unsavedDescription} = this.state;
        const model = {CourseId: parseInt(courseId), Description: unsavedDescription};
        this.setState({descriptionSubmitLoading: true});
        LevelApi.UpdateLevelDescription(model)
            .then(res => {
                if (res && res.status == 200) {
                    Notification('success', 'Succeed');
                    let {data} = this.state;
                    data.description = unsavedDescription;
                    this.setState({data, descriptionEditMode: false});
                }
            }).finally(() => {
            this.setState({descriptionSubmitLoading: false});
        });
    };

    handleCancelDescriptionEdit = () => {
        this.setState({descriptionEditMode: false, unsavedDescription: ''});
    };

    render() {
        const {
            data, loading, showAddDialog, levelName, createBtnLoading, descriptionEditMode, unsavedDescription,
            descriptionSubmitLoading
        } = this.state;

        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Level;

        const {description, levels} = data;

        return (
            <>
                <div className='m-3'>
                    <Button full type='success' shadowType='sm' onClick={() => {
                        this.setState({showAddDialog: true})
                    }}>
                        <i className='fa fa-plus font-weight-bold ml-2'/>
                        <span className='font-weight-bold font-14'>
                                    {pageTranslates.Create}
                    </span>
                    </Button>
                </div>

                {!data || !data.levels || data.levels.length == 0 ?
                    <NoRecord message='CourseLevel'/>
                    :
                    <CardContainer>
                        <div className='d-flex align-items-center'>
                            {descriptionEditMode ?
                                <>
                                    <Input className='font-13'
                                           placeholder={pageTranslates.Description} value={unsavedDescription}
                                           onChange={this.handleInputChange('unsavedDescription')}/>
                                    <IconButton icon='check' iconStyle={{color: 'darkgreen', fontSize: 12}}
                                                onClick={this.handleSubmitDescriptionEdit}
                                                loading={descriptionSubmitLoading}/>
                                    <IconButton icon='times' iconStyle={{color: 'darkred', fontSize: 12}}
                                                onClick={this.handleCancelDescriptionEdit}/>
                                </>
                                :
                                <>
                                    <IconButton icon='cog' iconStyle={{fontSize: 12}}
                                                onClick={this.handleEditDescriptionOnClick}/>
                                    <p className='font-13'>
                                        {description || pageTranslates.NoDescription}
                                    </p>
                                </>
                            }
                        </div>

                        <div className="list-group list-custom-small">
                            {levels.map((item, index) => {
                                const number = index + 1;
                                const {title} = item;

                                return (
                                    <a onClick={this._handleLevelClick.bind(this, item)}>
                                        <div className='float-right'>
                                            <i className='rounded-sm shadow-xl bg-primary'
                                               style={{fontStyle: 'normal'}}>
                                                {number}
                                            </i>
                                            <span>
                                    {title}
                                </span>
                                        </div>
                                        <div className='float-left'>
                                            <i className="fa fa-angle-left"></i>
                                        </div>
                                    </a>
                                );
                            })}
                        </div>
                    </CardContainer>
                }

                <Dialog open={showAddDialog} title={pageTranslates.Create}>
                    <div>
                        <div>
                            <label className='mb-0 color-primary'>
                                {pageTranslates.LevelName}
                            </label>
                            <Input placeholder={pageTranslates.LevelName} value={levelName}
                                   onChange={this.handleInputChange('levelName')}
                            />
                            {this.validator.message(pageTranslates.LevelName, levelName, 'required|min:3')}
                        </div>
                        <div>
                            <Button full onClick={this.handleSubmitAddClick} loading={createBtnLoading}>
                                {pageTranslates.CreateDialog.Submit}
                            </Button>
                            <Button full type='secondary' onClick={() => this.setState({showAddDialog: false})}>
                                {pageTranslates.CreateDialog.Cancel}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(LevelsTab));